import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { OperationNames } from "Types/operation";
import { StationType } from "Types/station";

interface IState {
  name: OperationNames | null;
  type: StationType | null;
}

const initialState: IState = {
  name: null,
  type: null,
};

export const operationSlice = createSlice({
  name: "operation",
  initialState,
  reducers: {
    changeOperation: (state, action: PayloadAction<IState>) => {
      const { name, type } = action.payload;
      return { name, type };
    },
    closeOperation: () => {
      return { name: null, type: null };
    },
  },
});

export const { changeOperation, closeOperation } = operationSlice.actions;

export default operationSlice.reducer;
